import { TranslationsEn } from '~/locales/translationEn';
import { TranslationsMx } from '~/locales/translationMx';
import { TranslationsZh } from '~/locales/translationZh';
import { createTranslationKeys, TranslationKeysType, useMagicLocalization } from './magicLocalization';

export const translations = {
  en: TranslationsEn,
  mx: TranslationsMx,
  zh: TranslationsZh,
} as const;

export const TranslationKeys = createTranslationKeys(translations);
export type TranslationKeys = TranslationKeysType<typeof translations.en>;
export const useLocalization = () => useMagicLocalization(translations);
